
<script>
  import { getContext } from 'svelte';

  const { yScale } = getContext('LayerCake');

  export let avg;

</script>


<line 
  x1="0"
  x2="100"
  y1="{$yScale(avg)}"
  y2="{$yScale(avg)}"
  stroke-width="0.2"
  stroke="#666"
  ></line>
